import { Stack, Tab, Tabs, Typography } from '@mui/material'
import {
  Person as UserIcon,
  Group as GroupIcon,
  Groups as TenantIcon,
  Business as ManufacturerIcon,
  Notifications as NotificationIcon,
  Handshake as AgreementIcon,
  ManageSearch as AuditLogIcon
} from '@mui/icons-material'

import { Link } from 'react-router-dom'

export type ConfigureTabIdentifier = 'user' | 'group' | 'tenant' | 'manufacturer' | 'notification' | 'agreement' | 'auditLog'

type ConfigureTabsProps = {
  active: ConfigureTabIdentifier
  onChangeActive: (active: ConfigureTabIdentifier) => void
  orientation: 'horizontal' | 'vertical'
}
export const ConfigureTabs = ({
  active,
  onChangeActive,
  orientation
}: ConfigureTabsProps) => {
  return (
    <Tabs
      orientation={orientation}
      variant="scrollable"
      value={active}
      sx={
        (orientation === 'horizontal') ? {
          width: '100%'
        } : {
          textAlign: 'right',
          height: '100%',
        }
      }
    >
      <Tab
        value='user'
        component={Link}
        to="?page=user"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('user')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <UserIcon/>
            <Typography variant="body2">ユーザー</Typography>
          </Stack>
        }
      />
      <Tab
        value='group'
        component={Link}
        to="?page=group"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('group')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <GroupIcon/>
            <Typography variant="body2">グループ</Typography>
          </Stack>
        }
      />
      <Tab
        value='tenant'
        component={Link}
        to="?page=tenant"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('tenant')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <TenantIcon/>
            <Typography variant="body2">テナント</Typography>
          </Stack>
        }
      />
      <Tab
        value='manufacturer'
        component={Link}
        to="?page=manufacturer"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('manufacturer')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <ManufacturerIcon/>
            <Typography variant="body2">製薬企業</Typography>
          </Stack>
        }
      />
      <Tab
        value='notification'
        component={Link}
        to="?page=notification"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('notification')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <NotificationIcon/>
            <Typography variant="body2">お知らせ</Typography>
          </Stack>
        }
      />
      <Tab
        value='agreement'
        component={Link}
        to="?page=agreement"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('agreement')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <AgreementIcon/>
            <Typography variant="body2">利用規約</Typography>
          </Stack>
        }
      />
      <Tab
        value='auditLog'
        component={Link}
        to="?page=auditLog"
        onClick={(e) => {
          e.preventDefault()
          onChangeActive('auditLog')
        }}
        label={
          <Stack direction="row" spacing={1} alignItems="center">
            <AuditLogIcon/>
            <Typography variant="body2">監査ログ</Typography>
          </Stack>
        }
      />
    </Tabs>
  )
}
